import { render, staticRenderFns } from "./RaceVideoPage.vue?vue&type=template&id=21e062fc"
import script from "./RaceVideoPage.vue?vue&type=script&lang=ts"
export * from "./RaceVideoPage.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoPage.vue?vue&type=style&index=0&id=21e062fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports